module.exports = __webpack_public_path__ + "img/trust__down-main-2.b0cc5fa1.jpg";